import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { registerDetails, registerList } from "../../api/register";
import {
  allStudentListForAClass,
  allStudentListForAnEvent,
  getAllOtherStudents,
  getAllOtherStudentsForEvent,
} from "../../api/student";
const initialState = {
  listR: [],
  totalR: 0,
  details: {},
  register_for: localStorage.getItem("register_for")
    ? localStorage.getItem("register_for")
    : "class",
  otherStudentsListForClass: [],
  otherStudentsListForEvents: [],
  level: localStorage.getItem("level") ? localStorage.getItem("level") : "",
  allStudentForClass: [],
  allStudentForEvent: [],
};

export const RegisterSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    listR: (state, action) => {
      state.listR = action.payload;
    },
    detail: (state, action) => {
      state.details = action.payload;
    },
    countR: (state, action) => {
      state.totalR = action.payload;
    },
    changeRegisterFor: (state, action) => {
      state.register_for = action.payload;
    },
    otherStudentListingForClass: (state, action) => {
      state.otherStudentsListForClass = action.payload;
    },
    otherStudentListingForEvent: (state, action) => {
      state.otherStudentsListForEvents = action.payload;
    },
    changeLevel: (state, action) => {
      state.level = action.payload;
    },
    allStudentForClass: (state, action) => {
      state.allStudentForClass = action.payload;
    },
    allStudentForEvent: (state, action) => {
      state.allStudentForEvent = action.payload;
    },
    clearAllStudentList: (state, action) => {
      state.allStudentForEvent = [];
      state.allStudentForClass = [];
    },
  },
});

export const FetchRegisterList = createAsyncThunk(
  "registerList",
  async (obj, { dispatch }) => {
    try {
      const response = await registerList(obj);
      if (response?.code === 1) {
        dispatch(listR(response?.data?.register_list));
        dispatch(countR(response?.data?.register_count));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchRegisterDetail = createAsyncThunk(
  "registerDetail",
  async (obj, { dispatch }) => {
    const response = await registerDetails(obj);
    if (response?.code === 1) {
      dispatch(detail(response?.data?.register_details));
    }
    return response;
  }
);

export const FetchAllOtherStudents = createAsyncThunk(
  "AllOtherStudents",
  async (obj, { dispatch }) => {
    try {
      const response = await getAllOtherStudents(obj);
      if (response?.code === 1) {
        console.log(response);
        dispatch(otherStudentListingForClass(response?.data?.student_list));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchAllOtherStudentsForEvent = createAsyncThunk(
  "AllOtherStudentsForEvent",
  async (obj, { dispatch }) => {
    try {
      const response = await getAllOtherStudentsForEvent(obj);
      if (response?.code === 1) {
        console.log(response);
        dispatch(otherStudentListingForEvent(response?.data?.student_list));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchAllStudentsForClass = createAsyncThunk(
  "AllStudentsForClass",
  async (obj, { dispatch }) => {
    try {
      const response = await allStudentListForAClass(obj);
      if (response?.code === 1) {
        console.log(response);
        dispatch(allStudentForClass(response?.data?.student_list));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchAllStudentsForEvent = createAsyncThunk(
  "AllStudentsForEvent",
  async (obj, { dispatch }) => {
    try {
      const response = await allStudentListForAnEvent(obj);
      if (response?.code === 1) {
        console.log(response);
        dispatch(allStudentForEvent(response?.data?.student_list));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);
export const {
  listR,
  detail,
  countR,
  clearAllStudentList,
  changeRegisterFor,
  allStudentForClass,
  allStudentForEvent,
  otherStudentListingForEvent,
  otherStudentListingForClass,
  changeLevel,
} = RegisterSlice.actions;

export default RegisterSlice.reducer;
